wbApp.factory('invoiceRecurrenceScheduleSvc', ['$resource', '$q', '$translate', '$filter', 'repositorySvc', 'notificationSvc', 'tenantSettingSvc', 'semesterSvc', 'activityStudentSettingSvc', 'activitySvc',
function ($resource, $q, $translate, $filter, repositorySvc, notificationSvc, tenantSettingSvc, semesterSvc, activityStudentSettingSvc, activitySvc) {

    //var ActivityReconciliations = $resource('/Api/ActivityReconciliations/:id', {}, {
    //    'getStudentsByActivity': { method: 'GET', isArray: true, url: '/Api/ActivityReconciliations/GetStudentsByActivity' },
    //    'getStudentsAttendanceByActivity': { method: 'GET', isArray: true, url: '/Api/ActivityReconciliations/GetStudentsAttendanceByActivity' },
    //    'getByStudentAndActivity': { method: 'GET', isArray: true, url: '/Api/ActivityReconciliations/GetByStudentAndActivity' },
    //    'getReconciliationDetail': { method: 'GET', isArray: false, url: '/Api/ActivityReconciliations/GetReconciliationDetail' },
    //    'insertReconciliationDetail': { method: 'POST', url: '/Api/ActivityReconciliations/InsertReconciliationDetail' },
    //    'updateReconciliationDetail': { method: 'POST', url: '/Api/ActivityReconciliations/UpdateReconciliationDetail' },
    //    'deleteReconciliationDetail': { method: 'POST', url: '/Api/ActivityReconciliations/DeleteReconciliationDetail' },
    //    'sendReconciliationNotification': { method: 'POST', url: '/Api/ActivityReconciliations/SendReconciliationNotification' },
    //    'getAvailableExuses': { method: 'GET', url: '/Api/ActivityReconciliations/GetAvailableExuses' }
    //});

   // var invoiceRecurrenceSchedules = [];

    var InvoiceRecurrenceSchedule = $resource('/Api/InvoiceRecurrenceSchedule/:id', {}, {
        'query': { method: 'GET', isArray: true },
        'update': { method: 'POST', url: '/Api/InvoiceRecurrenceSchedule/Update' },
        'insert': { method: 'POST', url: '/Api/InvoiceRecurrenceSchedule/Insert' },
        'delete': { method: 'POST', url: '/Api/InvoiceRecurrenceSchedule/Delete' },
        'getAllForStudentAndActivity': { method: 'GET', isArray: true, url: '/Api/InvoiceRecurrenceSchedule/GetAllForStudentAndActivity' }
    });

    function getAllForStudentAndActivity(semesterID, studentID, activityID) {
        var deferred = $q.defer();
        var result = [];

        $q.all([
            repositorySvc.customGet('getAllForStudentAndActivity', InvoiceRecurrenceSchedule, {
                studentID: studentID,
                activityID: activityID
            }).$promise,
          //  semesterSvc.getAsync(semesterID),
            activityStudentSettingSvc.getByStudentAndActivity(studentID, activityID).$promise,
            activitySvc.getBySemesterIDAndActivityID(semesterID, activityID)
        ]).then(function (data) {

            angular.forEach(data[0], function (m) {
                var model = new webooker_acivity_models.RecurringSchedule($translate);
                model.initData(m);
                model.tariffFullName = data[1].tariffName + ' (' + $filter('wbCurrencyFlt')(data[1].tariffPrice) + ')';
                // This does not look right! Why to update price on existing invoices: https://aperus.atlassian.net/browse/WEB-409
                //model.invoice.invoiceLineKindergartenSnackUnitPrice = data[2].defaultSnackPrice;
                //model.invoice.invoiceLineKindergartenLunchUnitPrice = data[2].defaultLunchPrice;
                result.push(model);
            });

            deferred.resolve(result);
        }, function (errorResult) {
            deferred.reject(errorResult);
        });

        result.$promise = deferred.promise;
        return result;
    }

    function createNew(semesterID, studentID, activityID) {
        var m = {
            invoiceRecurrenceScheduleID: 0,
            reccurenceUnitTypeID: 3,
            repeatEveryNoOfUnits: 1,
            endAfterNoOfIssues: null,
            studentID: studentID,
            activityID: activityID,
            semesterID: semesterID,
            startDate: moment().startOf('day').toDate(),
            active: true,
            invoice: {
                customerStudentID: studentID
            }
        };

        var model = new webooker_acivity_models.RecurringSchedule($translate);
        model.initData(m);

        var deferred = $q.defer();
        model.$promise = deferred.promise;

        $q.all([
            semesterSvc.getAsync(semesterID),
            activityStudentSettingSvc.getByStudentAndActivity(studentID, activityID).$promise,
            activitySvc.getBySemesterIDAndActivityID(semesterID, activityID)]
            ).then(function (data) {
                model.endAtSpecificDate = data[0].endDate;
                model.endIssueTypeID = 1;
                model.invoice.invoiceLineKindergartenFeeReccuringUnitPrice = data[1].tariffPrice;
                model.invoice.invoiceLineKindergartenFeeReccuringQty = 1;
                model.tariffFullName = data[1].tariffName + ' (' + $filter('wbCurrencyFlt')(data[1].tariffPrice) + ')';
                model.invoice.invoiceLineKindergartenSnackUnitPrice = data[2].defaultSnackPrice;
                model.invoice.invoiceLineKindergartenLunchUnitPrice = data[2].defaultLunchPrice;

                deferred.resolve(model);
        }, function (errorResult) {
            deferred.reject(errorResult);
        });

        return model;
    }

    function insert(data, successCallback, errorCallback) {

        var dto = data.getDTO($translate);

        repositorySvc.insert(
            InvoiceRecurrenceSchedule,  // $resource
            null,                       // collection
            dto,                        // entity
            successCallback,
            errorCallback);
    }


    function update(data, successCallback, errorCallback) {

        var dto = data.getDTO($translate);

        repositorySvc.update(
            InvoiceRecurrenceSchedule,  // $resource
            null,                       // collection
            dto,                        // entity
            successCallback,
            errorCallback,
            'invoiceRecurrenceScheduleID');
    }

    function remove(data, successCallback, errorCallback) {

        var dto = data.getDTO($translate);

        repositorySvc.remove(
            InvoiceRecurrenceSchedule,  // $resource
            null,                       // collection
            dto,                        // entity
            successCallback,            
            errorCallback,
            null,
            'invoiceRecurrenceScheduleID');
    }

    return {
        createNew: createNew,
        insert: insert,
        update: update,
        remove: remove,
        getAllForStudentAndActivity: getAllForStudentAndActivity
    }

}]);
